/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface VolumeSeries
 */
export interface VolumeSeries {
  /**
   *
   * @type {string}
   * @memberof VolumeSeries
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof VolumeSeries
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof VolumeSeries
   */
  readonly updated?: Date;
  /**
   *
   * @type {Date}
   * @memberof VolumeSeries
   */
  beginDate: Date;
  /**
   *
   * @type {Date}
   * @memberof VolumeSeries
   */
  endDate: Date;
  /**
   *
   * @type {VolumeSeriesWaterInOutEnum}
   * @memberof VolumeSeries
   */
  waterInOut: VolumeSeriesWaterInOutEnum;
  /**
   *
   * @type {VolumeSeriesTemperatureEnum}
   * @memberof VolumeSeries
   */
  temperature: VolumeSeriesTemperatureEnum;
  /**
   *
   * @type {number}
   * @memberof VolumeSeries
   */
  volume: number;
  /**
   *
   * @type {string}
   * @memberof VolumeSeries
   */
  report: string;
  /**
   *
   * @type {string}
   * @memberof VolumeSeries
   */
  dataOwner: string;
}

/**
 * @export
 */
export const VolumeSeriesWaterInOutEnum = {
  Ingebracht: "ingebracht",
  Onttrokken: "onttrokken",
} as const;
export type VolumeSeriesWaterInOutEnum =
  (typeof VolumeSeriesWaterInOutEnum)[keyof typeof VolumeSeriesWaterInOutEnum];

/**
 * @export
 */
export const VolumeSeriesTemperatureEnum = {
  Warm: "warm",
  Koud: "koud",
  Onbekend: "onbekend",
} as const;
export type VolumeSeriesTemperatureEnum =
  (typeof VolumeSeriesTemperatureEnum)[keyof typeof VolumeSeriesTemperatureEnum];

/**
 * Check if a given object implements the VolumeSeries interface.
 */
export function instanceOfVolumeSeries(value: object): value is VolumeSeries {
  if (
    (!("beginDate" in (value as Record<string, any>)) &&
      !("begin_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["beginDate"] === undefined &&
      (value as Record<string, any>)["begin_date"] === undefined)
  )
    return false;
  if (
    (!("endDate" in (value as Record<string, any>)) &&
      !("end_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["endDate"] === undefined &&
      (value as Record<string, any>)["end_date"] === undefined)
  )
    return false;
  if (
    (!("waterInOut" in (value as Record<string, any>)) &&
      !("water_in_out" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["waterInOut"] === undefined &&
      (value as Record<string, any>)["water_in_out"] === undefined)
  )
    return false;
  if (!("temperature" in value) || value["temperature"] === undefined) return false;
  if (!("volume" in value) || value["volume"] === undefined) return false;
  if (!("report" in value) || value["report"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function VolumeSeriesFromJSON(json: any): VolumeSeries {
  return VolumeSeriesFromJSONTyped(json, false);
}

export function VolumeSeriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeSeries {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    beginDate: new Date(json["begin_date"]),
    endDate: new Date(json["end_date"]),
    waterInOut: json["water_in_out"],
    temperature: json["temperature"],
    volume: json["volume"],
    report: json["report"],
    dataOwner: json["data_owner"],
  };
}

export function VolumeSeriesToJSON(json: any): VolumeSeries {
  return VolumeSeriesToJSONTyped(json, false);
}

export function VolumeSeriesToJSONTyped(
  value?: Omit<VolumeSeries, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    begin_date: value["beginDate"].toISOString().substring(0, 10),
    end_date: value["endDate"].toISOString().substring(0, 10),
    water_in_out: value["waterInOut"],
    temperature: value["temperature"],
    volume: value["volume"],
    report: value["report"],
    data_owner: value["dataOwner"],
  };
}
